import React, { useState } from 'react';
import css from './ContactForm.module.css';
import { sendEmailViaMailChimp } from '../../../../../util/api';

function ContactForm() {
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const formData = new FormData(form);

    const data = {
      firstName: formData.get("fname"),
      lastName: formData.get("lname"),
      email: formData.get("email"),
      subject: formData.get("subject"),
      message: formData.get("message"),
    };

    setLoading(true);
    setStatus("");

    try {
      await sendEmailViaMailChimp(data);
      setStatus("Message sent successfully!");
      form.reset();
    } catch (err) {
      console.error(err);
      setStatus("Failed to send message. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={css.contactFormWrapper}>
      <form onSubmit={handleSubmit}>
        <div className={css.formRow}>
          <div className={css.formControl}>
            <label>First Name</label>
            <input type="text" placeholder="First Name" name="fname" required />
          </div>
          <div className={css.formControl}>
            <label>Last Name</label>
            <input type="text" placeholder="Last Name" name="lname" required />
          </div>
        </div>
        <div className={css.formControl}>
          <label>Email *</label>
          <input type="email" placeholder="Email Address" name="email" required />
        </div>
        <div className={css.formControl}>
          <label>Subject</label>
          <input type="text" placeholder="Subject" name="subject" />
        </div>
        <div className={css.formControl}>
          <label>Your Message *</label>
          <textarea placeholder="Your Message" name="message" required />
        </div>
        <div className={css.submitButton}>
          <button type="submit" disabled={loading}>
            {loading ? "Sending..." : "Submit Form"}
          </button>
        </div>
        {status && <p>{status}</p>}
      </form>
    </div>
  );
}

export default ContactForm;
